<div *ngIf="space" class="room-container">
    <div *ngIf="space.signedImageUrl" class="img-background"
        [ngStyle]="{'background-image': 'url(' + space.signedImageUrl + ')'}">
    </div>
    <div class="content-violet"></div>
    <div class="content-text" *ngIf="visitTemplate && museum">
        <div class="logo-container">
            <img class="logo" [src]="signedLogo" alt="logo" *ngIf="signedLogo">
        </div>
        <div class="short-welcome">
            {{'waiting.welcome' | translate}} {{pseudo}} !
        </div>
        <div class="short-welcome">
            {{museum.name}} {{'waiting.welcomeTour' | translate}} <span
                style="font-style: italic; font-weight: 500;">{{visitTemplate.title}}</span>
            {{'waiting.schedule' | translate}} {{this.visitTemplate.startDateTime | timeDateString: "time_zone" |
            async}}
        </div>
        <div *ngIf="!visitTemplate.realStartedAt">
            <!-- Visit has not started yet -->
            <div class="countdown-msg" *ngIf="timeBeforeStart">
                {{'waiting.starts' | translate}}
                {{timeBeforeStart.hours > 0 ? timeBeforeStart.hours + " " +("hour(s)" | translate) : ''}}
                {{timeBeforeStart.minutes > 0 ? timeBeforeStart.minutes + " " +("minute(s)" | translate) : ''}}
            </div>
            <div class="countdown-msg" *ngIf="!timeBeforeStart">
                {{'waiting.guideLate' | translate}}
            </div>
        </div>
        <div *ngIf="visitTemplate.realStartedAt && !visitTemplate.realEndedAt && !connecting">
            <!-- Visit has started but is not over -->
            <div class="countdown-msg">
                {{'waiting.startedAlready' | translate}} {{timeSinceStart}} {{'waiting.minAgo' | translate}}
            </div>
        </div>
        <div *ngIf="visitTemplate.realStartedAt && visitTemplate.realEndedAt">
            <!-- Visit has started and is over -->
            <div class="countdown-msg">
                {{'waiting.visitEnded' | translate}}
            </div>
        </div>
        <div class="intro-title">
            {{'Introduction' | translate}}
        </div>
        <div class="intro-body-bold">
            {{summary}}
        </div>
        <div class="intro-body-regular">
            {{description}}
        </div>
        <div class="loader-container" *ngIf="connecting">
            <div class="d-flex justify-content-center">
                <div role="status" class="loading-div ">
                    <museum-loader [whitify]="true"></museum-loader>
                </div>
            </div>
        </div>

        <button id="join-btn" [disabled]="!visitTemplate.realStartedAt || connecting" (click)="onJoinClick()">
            {{ btnLabel | translate}}</button>

        <div *ngIf="!visitTemplate.realEndedAt" class="btn rounded-pill btn-museum btn-audio-settings" (click)="onOpenAudioSettings()">
            <span class="iconify" data-icon="mdi:tune-vertical" data-inline="false" data-width="24" data-height="24"
                style="color: #6f3974;"></span>
            {{'audio.settings.open' | translate}}
        </div>



    </div>
    <button class="logout-btn" (click)="onSignOut()">{{'Log out' | translate}}</button>



</div>